import { 
    createApi, 
    fetchBaseQuery 
} from "@reduxjs/toolkit/query/react";
import { 
    setCredentials, 
    clearCredentials 
} from "../stores/authSlice";

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BACKEND_URL, 
    credentials: "include",
    prepareHeaders: (headers, { getState }) => {
        const token = getState().auth.token;

        if(token) {
            headers.set("authorization", `Bearer ${token}`);
        };

        return headers;
    }
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    if(result?.error?.status === 403) {
        const refreshResult = await baseQuery("/auth/refresh", api, extraOptions);

        if(refreshResult?.data) {
            // store the new access token
            api.dispatch(setCredentials({ ...refreshResult.data }));

            // retry original query with new access token
            result = await baseQuery(args, api, extraOptions);

        } else {
            // otherwise sign the user out
            api.dispatch(clearCredentials());

            // clear cached user data
            api.dispatch(api.util.resetApiState());
        }
    }

    return result;
};

export const apiSlice = createApi({
    reducerPath: "api",
    tagTypes: ["emblems", "tournaments", "user", "calender"],
    baseQuery: baseQueryWithReauth,
    endpoints: builder => ({})
});